import { API_BASE_URL } from '../../../../../config';
import type { BankAccountFormValues } from './bankAccountDetailsTypes';

export const DONE_STEP_ID = '__done__';

export type BankAccountDetailsProgressPayload = {
  values: BankAccountFormValues;
  currentStepId: string | null;
};

export async function fetchBankAccountDetailsProgress(
  email: string
): Promise<BankAccountDetailsProgressPayload | null> {
  if (!API_BASE_URL || !email?.trim()) return null;
  const params = new URLSearchParams({ email: email.trim() });
  const r = await fetch(`${API_BASE_URL}/api/bank-account-details/progress?${params.toString()}`);
  if (!r.ok) return null;
  const data = (await r.json()) as {
    values?: BankAccountFormValues;
    currentStepId?: string | null;
  };
  return {
    values: data.values && typeof data.values === 'object' ? data.values : {},
    currentStepId: data.currentStepId ?? null,
  };
}

export async function upsertBankAccountDetailsProgress(params: {
  email: string;
  values: BankAccountFormValues;
  currentStepId: string | null;
}): Promise<boolean> {
  if (!API_BASE_URL || !params.email?.trim()) return false;
  try {
    const r = await fetch(`${API_BASE_URL}/api/bank-account-details/progress`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: params.email.trim(),
        values: params.values,
        currentStepId: params.currentStepId,
      }),
    });
    if (!r.ok) {
      console.warn('Bank account details save failed', r.status);
      return false;
    }
    return true;
  } catch (e) {
    console.warn('Bank account details save failed', e);
    return false;
  }
}
